// dependencies imports ⇒
import React, { useEffect, useRef, useState } from "react";
import Validator from "aadhaar-validator";

// assets and scss imports ⇒
import "./createAbhaFromMobileVerification.scss";
import backArrow from "../../../../assets/back_arrow_gray.svg";
import tickIcon from "../../../../assets/tick.svg";
import anthemLogo from "../../../../assets/anthem-logo.png";

import LearnMorePopup from "../../../common/Popups/LearnMorePopup";
import AbhaActionButton from "../../../AbhaViewContainer/common/AbhaActionButton";
import TermsAndConditionPopup from "../../../common/Popups/TermsAndConditionPopup";
import AbhaOtpContainer from "../AbhaOtpContainer";
import AbhaCreateAddress from "../AbhaCreateAddress";
import AbhaMobileNumberLink from "../AbhaMobileNumberLink";
import { handleAbhaGenderFormat } from "../helper";
import { AADHAR_VALIDATION_ERROR, OTP_VALIDATION_ERROR } from "../../Constants";
import {
  enrollAadhar,
  enrollResendOtp,
  enrollVerifyOtp,
} from "../../APIHandler";
import {
  ENROLL_AADHAR,
  ENROLL_RESEND_OTP,
  ENROLL_VERIFY_OTP,
} from "../../APIHandler/apiConstants";
// project file imports(UI components) ⇒

// const file imports(helper methods, etc) ⇒

const CreateAbhaFromMobileVerification = (props) => {
  const { mobileNumber, handleConfirmationModal } = props;
  // const declarations ⇒
  const [aadharInput, setAadharInput] = useState({
    first: "",
    middle: "",
    last: "",
  });
  const [inputFocused, setInputFocused] = useState("");
  const [aadharError, setAadharError] = useState("");
  const [checked, setChecked] = useState(false);
  const [showLearnMore, setShowLearnMore] = useState(false);
  const [showTermsAndConditions, setShowTermsAndConditions] = useState(false);
  const [disableActionButton, setDisableActionButton] = useState(true);
  const [errorMessage, setErrorMessage] = useState();
  const firstRef = useRef();
  const middleRef = useRef();
  const lastRef = useRef();

  const [transactionID, setTransactionID] = useState("");
  const [aadharMobileNumber, setAadharMobileNumber] = useState("");
  const [aadharNumber, setAadharNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [disableAadharOtpButton, setDisableAadharOtpButton] = useState(true);
  const [patientId, setPatientId] = useState("");
  const [abhaNumber, setAbhaNumber] = useState("");
  const [abhPatientDetails, setAbhPatientDetails] = useState({});
  const [enteredMobileNumber, setEnteredMobileNumber] = useState("");
  const [createAadharSteps, setCreateAadharSteps] = useState(1);
  const [hideTimerResendBtn, setHideTimerResendBtn] = useState(false);

  // life cycle methods ⇒
  useEffect(() => {
    let aadharNumber =
      aadharInput.first + aadharInput.middle + aadharInput.last;
    if (aadharNumber?.length === 12 && checked) {
      setDisableActionButton(false);
    } else {
      setDisableActionButton(true);
    }
  }, [aadharInput, checked]);

  useEffect(() => {
    if (otp?.length < 6) {
      setDisableAadharOtpButton(true);
    } else {
      setDisableAadharOtpButton(false);
    }
  }, [otp]);

  useEffect(() => {
    setEnteredMobileNumber(mobileNumber);
  }, [mobileNumber]);

  // API Calls ⇒
  const enrollAadharAPICall = (reqPayload) => {
    const aadharResponse = enrollAadhar(ENROLL_AADHAR, reqPayload); //Fetch API Data
    aadharResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode == 200) {
          setDisableActionButton(false);
          let responseData = res?.data;
          let mobileNumber = responseData.message.split(" ");
          handleAadharData(
            reqPayload?.aadhar_number,
            responseData?.txnId,
            mobileNumber[mobileNumber.length - 1]
          );
        } else if (res?.data?.statusCode == 503) {
          setDisableActionButton(false);
          setAadharError(res?.data?.message);
        } else if (res?.data?.statusCode == 400) {
          setDisableActionButton(false);
          setAadharError(AADHAR_VALIDATION_ERROR.THIRD_ERROR);
        } else {
          setDisableActionButton(false);
          setAadharError(
            res?.data?.code
              ? AADHAR_VALIDATION_ERROR.SECOND_ERROR
              : AADHAR_VALIDATION_ERROR.FIRST_ERROR
          );
        }
      } else {
        setAadharError(AADHAR_VALIDATION_ERROR.SECOND_ERROR);
        setDisableActionButton(false);
      }
    });
  };

  const enrollVerifyOtpAPICall = (reqPayload) => {
    const aadharResponse = enrollVerifyOtp(ENROLL_VERIFY_OTP, reqPayload); //Fetch API Data
    aadharResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode == 200) {
          setDisableAadharOtpButton(false);
          setOtpError(false);
          let responseData = res?.data;
          handlePatientId(responseData?.patient_master_id);
          if (responseData?.isNew) {
            if (responseData?.is_aadhar_mobile_no) {
              handleAbhaNumber(responseData?.ABHAProfile?.ABHANumber);
              setCreateAadharSteps(4);
            } else {
              setCreateAadharSteps(3);
            }
          } else {
            handleAbhaNumber(responseData?.ABHAProfile?.ABHANumber);
            let abhaDeatils = {
              name: `${responseData?.ABHAProfile?.firstName} ${
                responseData?.ABHAProfile?.middleName
                  ? responseData?.ABHAProfile?.middleName
                  : ""
              } ${
                responseData?.ABHAProfile?.lastName
                  ? responseData?.ABHAProfile?.lastName
                  : ""
              }`,
              dob: responseData?.ABHAProfile?.dob,
              gender: handleAbhaGenderFormat(responseData?.ABHAProfile?.gender),
              address: responseData?.ABHAProfile?.address,
              state: responseData?.ABHAProfile?.stateName,
              preferred_abha_address:
                responseData?.ABHAProfile?.phrAddress?.length > 0 &&
                responseData?.ABHAProfile?.phrAddress[0]?.split("@")[0],
            };
            setAbhPatientDetails(abhaDeatils);
            handleConfirmationModal(abhaDeatils);
          }
        } else {
          setErrorMessage(
            res?.data?.code
              ? res?.data?.code?.toLowerCase() == "abdm-1100"
                ? OTP_VALIDATION_ERROR?.THIRD_ERROR
                : OTP_VALIDATION_ERROR?.SECOND_ERROR
              : OTP_VALIDATION_ERROR?.FIRST_ERROR
          );
          setOtpError(true);
          setDisableAadharOtpButton(false);
        }
      } else {
        setErrorMessage(OTP_VALIDATION_ERROR.SECOND_ERROR);
        setOtpError(true);
        setDisableAadharOtpButton(false);
      }
    });
  };

  const enrollResendOtpAPICall = (reqPayload) => {
    const aadharResendOTPResponse = enrollResendOtp(
      ENROLL_RESEND_OTP,
      reqPayload
    ); //Fetch API Data
    aadharResendOTPResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode == 200) {
          setTransactionID(res?.data?.txnId);
          setHideTimerResendBtn(false);
        } else if (res?.data?.statusCode == 503) {
          setErrorMessage(res?.data?.message);
          setOtpError(true);
          setHideTimerResendBtn(true);
        } else {
          setErrorMessage(
            res?.data?.code?.toLowerCase() == "abdm-1100"
              ? OTP_VALIDATION_ERROR?.THIRD_ERROR
              : OTP_VALIDATION_ERROR?.SECOND_ERROR
          );
          setOtpError(true);
        }
      }
    });
  };

  // Actions ⇒
  const handleAadharData = (aadhar_number, transaction_id, aadharMobile) => {
    setAadharNumber(aadhar_number);
    setAadharMobileNumber(aadharMobile);
    setTransactionID(transaction_id);
    setCreateAadharSteps(2);
  };

  const handleAadharInput = (e, position) => {
    setAadharError("");
    let value = e.target.value;
    if (value?.length <= 4) {
      setAadharInput({
        ...aadharInput,
        [position]: value,
      });
    }
    if (value.length === 4 && position === "first") {
      middleRef.current.focus();
      setInputFocused("middle");
    } else if (value.length === 4 && position === "middle") {
      lastRef.current.focus();
      setInputFocused("last");
    }
  };

  const handleOnFocus = (position) => {
    setInputFocused(position);
  };

  const handleOnKeyDown = (e) => {
    const pressedKey = e.key;
    switch (pressedKey) {
      case "Backspace":
      case "Delete": {
        if (aadharInput[inputFocused]?.length === 0) {
          if (inputFocused === "last") {
            middleRef.current.focus();
          } else if (inputFocused === "middle") {
            firstRef.current.focus();
          }
        }
        break;
      }
      default: {
        if (
          e.key?.toLowerCase() === "e" ||
          e.key === "+" ||
          e.key === "-" ||
          e.key === "." ||
          e.key === "ArrowUp" ||
          e.key === "ArrowDown"
        ) {
          e.preventDefault();
        }
        break;
      }
    }
  };

  const handleTermsAndCondition = () => {
    setChecked(!checked);
  };

  const handleBack = () => {
    setShowLearnMore(false);
    setShowTermsAndConditions(false);
  };

  const handleVerifyAadhar = () => {
    let aadharNumber =
      aadharInput.first + aadharInput.middle + aadharInput.last;
    if (Validator.isValidNumber(aadharNumber)) {
      setAadharError("");
      setDisableActionButton(true);
      if (checked) {
        let payload = {
          aadhar_number: aadharNumber,
        };
        enrollAadharAPICall(payload);
      }
    } else {
      setAadharError(AADHAR_VALIDATION_ERROR?.FIRST_ERROR);
      setDisableActionButton(false);
    }
  };

  const handleOnPaste = (e) => {
    e.preventDefault();
    let copiedVaue = e.clipboardData.getData("text/plain");
    let value = copiedVaue.replaceAll(" ", "");
    if (value?.trim()?.length == 12) {
      if (!isNaN(value)) {
        const result = copiedVaue?.trim().match(/.{1,4}/g) || [];
        setAadharInput({
          first: result[0],
          middle: result[1],
          last: result[2],
        });
        lastRef.current.focus();
      }
    }
  };

  const handleOTPChange = (otpInput) => {
    setOtp(otpInput);
  };

  const handleAadharOtpVerification = () => {
    setDisableAadharOtpButton(true);
    let payload = {
      otp: otp,
      txnid: transactionID,
      mobile_number: mobileNumber,
    };
    enrollVerifyOtpAPICall(payload);
  };

  const handleResendOTP = () => {
    let payload = {
      aadhar_number: aadharNumber,
    };
    enrollResendOtpAPICall(payload);
  };

  const handlePatientId = (patient_id) => {
    setPatientId(patient_id);
  };

  const handleAbhaNumber = (abha_number) => {
    setAbhaNumber(abha_number);
  };

  const handleMobileNumberChange = (number) => {
    setEnteredMobileNumber(number);
  };

  const handleAbhaPatientDetails = (details) => {
    let abhaDeatils = {
      name: details?.name,
      dob: `${details?.dayOfBirth ? details?.dayOfBirth : "01"}-${
        details?.monthOfBirth ? details?.monthOfBirth : "01"
      }-${details?.yearOfBirth}`,
      gender: handleAbhaGenderFormat(details?.gender),
      address: details?.address,
      state: details?.stateName,
      pincode: details?.pincode,
      preferred_abha_address:
        details?.phrAddress && details?.phrAddress?.length > 0
          ? details?.phrAddress[0]?.split("@")[0]
          : details?.preferredAbhaAddress
          ? details?.preferredAbhaAddress?.split("@")[0]
          : "",
    };
    setAbhPatientDetails(abhaDeatils);
    handleConfirmationModal(abhaDeatils);
  };

  // create UI ⇒
  const abhaAadharCreateInstruction = () => {
    return (
      <div className="aavv-ci">
        Create your ABHA number using Aadhaar instantaneously. Please ensure
        that Aadhaar is linked to a Mobile Number as an OTP authentication will
        follow. If you do not have a Mobile Number linked, visit the nearest{" "}
        <span>
          <a
            href={"https://facility.ndhm.gov.in/"}
            target="_blank"
            className="aavv-terms-link-selected"
          >
            ABDM participating facility
          </a>{" "}
          and seek assistance.
        </span>
      </div>
    );
  };

  const abhaAadharCreateButton = () => {
    return (
      <div className="aavv-button-container">
        <AbhaActionButton
          title={"Create ABHA"}
          disabled={disableActionButton}
          handleClick={handleVerifyAadhar}
        />
      </div>
    );
  };

  const abhaAadharInputUI = () => {
    return (
      <div>
        <div className="aavv-input-label">Enter Your Aadhaar Number</div>
        <div className="aavv-input-container-view">
          <div
            className={
              "aavv-input-container " +
              (aadharError ? "aavv-input-container-error" : "")
            }
          >
            <input
              className="aavv-input"
              placeholder="****"
              maxLength={4}
              type="number"
              value={aadharInput.first}
              onChange={(e) => handleAadharInput(e, "first")}
              ref={firstRef}
              onKeyDown={handleOnKeyDown}
              onFocus={() => handleOnFocus("first")}
              onPaste={handleOnPaste}
            />
          </div>
          <div
            className={
              "aavv-input-container " +
              (aadharError ? "aavv-input-container-error" : "")
            }
          >
            <input
              className="aavv-input"
              placeholder="****"
              maxLength={4}
              type="number"
              value={aadharInput.middle}
              onChange={(e) => handleAadharInput(e, "middle")}
              ref={middleRef}
              onKeyDown={handleOnKeyDown}
              onFocus={() => handleOnFocus("middle")}
              onPaste={handleOnPaste}
            />
          </div>
          <div
            className={
              "aavv-input-container " +
              (aadharError ? "aavv-input-container-error" : "")
            }
          >
            <input
              className="aavv-input"
              placeholder="****"
              maxLength={4}
              type="number"
              value={aadharInput.last}
              onChange={(e) => handleAadharInput(e, "last")}
              ref={lastRef}
              onKeyDown={handleOnKeyDown}
              onFocus={() => handleOnFocus("last")}
              onPaste={handleOnPaste}
            />
          </div>
        </div>
        {aadharError && <div className="aavv-input-error">{aadharError}</div>}
      </div>
    );
  };

  const abhaAadharHeadingAndSubheadingUI = () => {
    return (
      <>
        <div className="aavv-subheading">
          <span className="aavv-subheading-bold">ABHA</span> (Health ID) Card
        </div>
        <div className="aavv-about">
          In coordination with NHA, Govt. of India, Connect2Clinic securely
          provides facility to create ABHA No.
        </div>
      </>
    );
  };

  const aabhaTermsAndConditionUI = () => {
    return (
      <div className="aavv-terms-container">
        <div
          onClick={handleTermsAndCondition}
          className={
            "aavv-terms-checkbox " +
            (checked ? "aavv-terms-checkbox-selected" : "")
          }
        >
          {checked && <img src={tickIcon} alt="" />}
        </div>
        <div className="aavv-terms-text">
          <p>
            Patient’s consent to give the necessary permission to Connect2Clinic
            to set up ABHA ID{" "}
            <span
              className="aavv-terms-Learn-more"
              onClick={() => {
                setShowLearnMore(true);
              }}
            >
              Learn More
            </span>
            <span
              className="aavv-terms-tac"
              onClick={() => {
                setShowTermsAndConditions(true);
              }}
            >
              Terms and Conditions
            </span>
          </p>
        </div>
      </div>
    );
  };

  const abhaAadharMainHeading = () => {
    return (
      <div className="aavv-main-heading">
        Create Ayushman Bharat Health Account
      </div>
    );
  };

  const abhaAadharValidationUI = () => {
    return (
      <div>
        {/* {abhaAadharMainHeading()} */}
        {abhaAadharHeadingAndSubheadingUI()}
        {abhaAadharInputUI()}
        {abhaAadharCreateInstruction()}
        {aabhaTermsAndConditionUI()}
        {abhaAadharCreateButton()}
      </div>
    );
  };

  const aadharOtpInputSection = () => {
    return (
      <div>
        <AbhaOtpContainer
          otpLabel="Enter OTP"
          otpContent={getOtpContent()}
          otp={otp}
          otpError={otpError}
          hideTimerResendBtn={hideTimerResendBtn}
          otpErrorMessage={errorMessage}
          disabled={disableAadharOtpButton}
          mobileVerificationFlow={true}
          handleOTPChange={handleOTPChange}
          handleResendOTP={handleResendOTP}
          handleSubmit={handleAadharOtpVerification}
        />
      </div>
    );
  };

  const aadharVerifyDifferentMobileNumber = () => {
    return (
      <div>
        <AbhaMobileNumberLink
          aadharNumber={aadharNumber}
          transactionID={transactionID}
          aadharMobileNumber={aadharMobileNumber}
          enteredMobileNumber={enteredMobileNumber}
          patientId={patientId}
          handleSteps={(steps) => {
            setCreateAadharSteps(steps);
          }}
          handleAbhaNumber={handleAbhaNumber}
          handleMobileNumberChange={handleMobileNumberChange}
        />
      </div>
    );
  };

  const aadharCreateAbha = () => {
    return (
      <div>
        <AbhaCreateAddress
          aadharNumber={aadharNumber}
          transactionID={transactionID}
          aadharMobileNumber={aadharMobileNumber}
          patientId={patientId}
          abhaNumber={abhaNumber}
          mobileAbhaCreateFlow={true}
          handleSteps={(steps) => {
            setCreateAadharSteps(steps);
          }}
          handleAbhaPatientDetails={handleAbhaPatientDetails}
        />
      </div>
    );
  };

  const getOtpContent = () => {
    return (
      <div>
        <div className="pavc-otp-content-text">
          We just sent you OTP on your mobile number which is linked to your
          Aadhar card.
        </div>
        <div className="pavc-otp-aadhar-text">
          Aadhar Mobile Number {aadharMobileNumber}
        </div>
      </div>
    );
  };

  const abhaContainerWrapper = () => {
    return (
      <div>
        <div>{abhaAadharMainHeading()}</div>
        <div>
          {createAadharSteps === 1 && abhaAadharValidationUI()}
          {createAadharSteps === 2 && aadharOtpInputSection()}
          {createAadharSteps === 3 && aadharVerifyDifferentMobileNumber()}
          {createAadharSteps === 4 && aadharCreateAbha()}
        </div>
        <div className="aavv-footer-img">
          <img src={anthemLogo} alt="" />
        </div>
      </div>
    );
  };

  return (
    <div className="create-abha-from-moblie-verification">
      {(showLearnMore || showTermsAndConditions) && (
        <div style={{ display: "flex", marginBottom: "30px" }}>
          <img
            src={backArrow}
            alt=""
            className="pavc-back-btn"
            onClick={handleBack}
          />

          <div className="cafmv-header">
            {showTermsAndConditions
              ? "Terms and Codition"
              : "Create ABHA (Health ID) Card"}
          </div>
        </div>
      )}
      {showLearnMore && <LearnMorePopup isPopup={false} />}
      {showTermsAndConditions && <TermsAndConditionPopup isPopup={false} />}
      {!showLearnMore && !showTermsAndConditions && abhaContainerWrapper()}
    </div>
  );
};

// export ⇒

export default CreateAbhaFromMobileVerification;
